import styled from 'styled-components';

export const StyledCompanyFeed = styled('div')`
  transform: translateX(-${({ theme }) => theme.x1spacePx}px);
`;
